import * as React from "react";
import OptionRow from "./OptionRow";

import FilterContext from "./context/Filter";

import OptionForm from "./OptionForm";

import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";

import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

const OptionsList = () => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const ctx = React.useContext(FilterContext);

  return (
    <>
      <h2 className="vm-text-gray-600 vm-text-base vm-mb-2 vm-block vm-text-right">
        {ctx.state.options.length} {ctx.state.title}
        {ctx.state.options.length > 1 ? "s" : ""}
      </h2>
      <div className="vm-mb-4 vm-border vm-rounded">
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={(event) =>
            ctx.dispatch({ type: `SORT_OPTIONS`, payload: event })
          }
        >
          <SortableContext
            items={ctx.state.options.map((option) => option.id)}
            strategy={verticalListSortingStrategy}
          >
            {ctx.state.options.map((option) => (
              <OptionRow key={option.id} id={option.id} option={option} />
            ))}
          </SortableContext>
        </DndContext>
      </div>
      <OptionForm />
    </>
  );
};

export default OptionsList;
